<template>
<div :class="{'pa-2 ma-2': $vuetify.breakpoint.mdAndUp}" style="padding-bottom: 70px !important">
    <im-header :loading="loading_data">
        <template v-slot:title>
            <div v-if="$route.params.id" class="text-truncate">
                <v-icon size="32" class="" @click="back()">keyboard_arrow_left</v-icon>{{name}}
            </div>
            <div v-else>
                <v-icon size="32" class="" @click="back()">keyboard_arrow_left</v-icon>{{ $t('rate_plan.title_create') }}
            </div>
        </template>
        <template v-slot:button>
            <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn-toggle class="group-btn" mandatory v-model="rate_plan.stop_sell">
                    <v-btn color="green" small :value="false">{{ $t('rate_plan.status.active') }}</v-btn>
                    <v-btn color="red" small :value="true">{{ $t('rate_plan.status.inactive') }}</v-btn>
                </v-btn-toggle>
            </template>
            <template v-else>
                <im-switch :value="rate_plan.stop_sell" @update="rate_plan.stop_sell = $event" style="justify-content: flex-end"></im-switch>
            </template>
        </template>
    </im-header>

    <v-alert class="mx-3 mb-1" dismissible v-if="rate_plan.stop_sell&&!loading_data" elevation="3" text outlined color="deep-orange" icon="warning" transition="slide-y-transition">
        Acest plan tarifar este inactiv
    </v-alert>

    <transition name="component-fade" mode="out-in">
        <v-container v-if="!loading_data" grid-list-md fluid :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-2': true}">
            <v-form v-model="valid" ref="form_rate_plan">
                <v-row class="im-card-items" no-gutters>
                    <v-col class="pa-2" md="4" cols="12">
                        <v-card class="im-card" flat height="100%">
                            <v-card-text>
                                <div>
                                    <v-text-field class="px-2" :label="$t('rate_plan.name')" v-model="rate_plan.name" required :rules="rules.name" />
                                </div>
                                <v-expand-transition mode="out-in">
                                    <div v-if="parent_plans.length&&!rate_plan.component_based">
                                        <v-checkbox :label="$t('rate_plan.parent')" v-model="parent" :hint="$t('rate_plan.info_text.parent')" persistent-hint />
                                    </div>
                                </v-expand-transition>
                                <v-expand-transition mode="out-in">
                                    <div v-if="!parent&&hotel.context == 'imemento'&&admin">
                                        <v-checkbox :label="$t('rate_plan.component_based')" v-model="rate_plan.component_based" :hint="$t('rate_plan.info_text.component_based')" persistent-hint />
                                    </div>
                                </v-expand-transition>

                                <v-expand-transition mode="out-in">
                                    <div v-if="parent">
                                        <v-select v-model="rate_plan.parent_id" :items="parent_plans" item-text="name" item-value="id" :label="$t('rate_plan.parent_id')" :rules="parent?rules.parent:[]" clearable />
                                    </div>
                                </v-expand-transition>
                                <v-row v-if="parent&&rate_plan.parent_id" no-gutters align="center">
                                    <v-col cols="12" sm="4" class="px-1">
                                        <v-select v-model="rate_plan.config.formula.operation" :items="parent_fromula.operation" :label="$t('rate_plan.formula.operation.method')">
                                            <template v-slot:selection="data">
                                                <span class="text-capitalize">{{ $t('rate_plan.formula.operation.' + data.item) }}</span>
                                            </template>
                                            <template v-slot:item="data">
                                                <span class="text-capitalize">{{ $t('rate_plan.formula.operation.' + data.item) }}</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="6" sm="4" class="px-1">
                                        <v-text-field class="number-input" :label="$t('rate_plan.formula.operation.value')" v-model="rate_plan.config.formula.value" type="number" />
                                    </v-col>
                                    <v-col cols="6" sm="4" class="px-1">
                                        <v-select v-model="rate_plan.config.formula.type" :items="parent_fromula.type" item-text="name" item-value="id" :label="$t('rate_plan.formula.operation.type')">
                                            <template v-slot:selection="data">
                                                <span v-if="data.item == 'flat'" class="text-capitalize">{{ hotel.currency }}</span>
                                                <span v-else class="text-capitalize">{{ $t('rate_plan.formula.type.' + data.item) }}</span>
                                            </template>
                                            <template v-slot:item="data">
                                                <span v-if="data.item == 'flat'" class="text-capitalize">{{ hotel.currency }}</span>
                                                <span v-else class="text-capitalize">{{ $t('rate_plan.formula.type.' + data.item) }}</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <div class="my-2" v-if="admin">
                                    <div class="important">
                                        {{ $t('rate_plan.price') }}
                                    </div>
                                    <div class="faded">
                                        <span v-if="rate_plan.net_prices">{{ $t('rate_plan.info_text.price_net') }}</span>
                                        <span v-else>{{ $t('rate_plan.info_text.price_gross') }}</span>
                                    </div>
                                    <div class="pa-2">
                                        <v-btn-toggle slot="button" class="group-btn px-1" mandatory v-model="rate_plan.net_prices">
                                            <v-btn color="blue" small :value="false">{{ $t('rate_plan.price_gross') }}</v-btn>
                                            <v-btn color="orange" small :value="true">{{ $t('rate_plan.price_net') }}</v-btn>
                                        </v-btn-toggle>
                                    </div>
                                </div>

                                <div>
                                    <v-select v-model="rate_plan.cancellation_policy_id" :items="policies" item-text="name" item-value="id" :hint="$t('rate_plan.info_text.cancellation_policy')" :label="$t('rate_plan.policy')" persistent-hint
                                        clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" />
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pa-2" md="4" cols="12">
                        <v-card class="im-card" flat height="100%">
                            <v-card-text>
                                <div class="important pa-1">
                                    {{ $t('rate_plan.meal_type') }}
                                </div>
                                <div class="pa-2">
                                    <v-checkbox class="pa-0 ma-0" :label="$t('rate_plan.meal_types.breakfast')" v-model="breakfast" @change="all_inclusive?all_inclusive=false:''" />
                                    <v-checkbox class="pa-0 ma-0" :label="$t('rate_plan.meal_types.lunch')" v-model="lunch" @change="all_inclusive?all_inclusive=false:''" />
                                    <v-checkbox class="pa-0 ma-0" :label="$t('rate_plan.meal_types.dinner')" v-model="dinner" @change="all_inclusive?all_inclusive=false:''" />
                                    <v-checkbox class="pa-0 ma-0" :label="$t('rate_plan.meal_types.all_inclusive')" v-model="all_inclusive" :hint="$t('rate_plan.info_text.all_inclusive')" persistent-hint @change="all_inclusive?(breakfast=true,lunch=true,dinner=true):''" />
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pa-2" md="4" cols="12">
                        <v-card class="im-card" flat height="100%">
                            <v-card-text>
                                <div class="important pa-2">
                                    {{ $t('rate_plan.title_room_association') }}
                                </div>
                                <div v-if="room_types.length < 1" class="pa-2">
                                    {{ $t('rate_plan.message_no_room') }}
                                </div>
                                <div v-else class="pa-2">
                                    <template v-for="(room, index) in room_types">
                                        <v-checkbox class="pa-0 ma-0" v-model="room_types_selected" :value="room.id" :key="index" color="primary">
                                            <template v-slot:label>
                                                <span v-if="room.name">{{room.name}}</span>
                                                <span v-else>{{$t('room_type_slug.' +room.slug)}}</span>
                                                <span class="faded">({{room.id}})</span>
                                            </template>
                                        </v-checkbox>
                                    </template>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </transition>

    <v-snackbar v-model="error_data" color="error" bottom left>
        <div>
            <div>Numele este obligatoriu</div>
        </div>
    </v-snackbar>

    <!--delete dialog-->
    <im-dialog-confirmation :dialog="delete_dialog" @cancel="delete_dialog=false" :loading="loading_delete" @delete="destroy()">
        <span slot="text-confirmation">{{ $t('rate_plan.message_delete_confimation') }}</span>
    </im-dialog-confirmation>
    <!--./delete dialog -->
    <!-- footer -->
    <im-footer :create='!!(rate_plan.id)' :update="modified&&!modified_room_selection&&(meal_type === rate_plan.meal_type)" :loading="loading_save" @save="saveItem()" @refresh="refresh()" @delete="deleteItem()" />
    <!-- ./ footer -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMFooter from '../../components/utils/IMFooter.vue';
import IMInfo from '../../components/small-components/IMInfo.vue';
import IMSwitch from '../../components/small-components/IMSwitch.vue';
import ImDialogConfirmation from '../../components/utils/ImDialogConfirmation.vue';


export default {
    props: ['hotel', 'rate_plan_name'],
    components: {
        "im-header": IMHeader,
        "im-footer": IMFooter,
        "im-info": IMInfo,
        "im-switch": IMSwitch,
        "im-dialog-confirmation": ImDialogConfirmation
    },

    data() {
        return {
            rate_pos: ["hello-romania"],

            error_data: false,
            parent: false,
            parent_plans: [],
            parent_fromula: {
                operation: [],
                type: [],
            },
            currency: this.hotel.currency,
            admin: false,
            valid: false,
            loading_data: false,
            loading_delete: false,
            delete_dialog: false,
            modified: true,
            modified_room_selection: true,
            name: this.$clone(defaults.rate_plan_name),

            // meal types
            breakfast: false,
            lunch: false,
            dinner: false,
            all_inclusive: false,
            // days
            today: new Date()
                .toISOString()
                .substr(0, 10),
            menu_period_start: null,
            menu_period_stop: null,
            days: [
                {
                    text: "monday",
                    value: "1",
                    selected: false
                }, {
                    text: "tuesday",
                    value: "2",
                    selected: false
                }, {
                    text: "wednesday",
                    value: "3",
                    selected: false
                }, {
                    text: "thursday",
                    value: '4',
                    selected: false
                }, {
                    text: "friday",
                    value: "5",
                    selected: false
                }, {
                    text: "saturday",
                    value: "6",
                    selected: false
                }, {
                    text: "sunday",
                    value: "0",
                    selected: false
                }
            ],
            points_of_sales: [],
            policies: [],
            meal_types: [],
            room_types: [],
            room_types_selected: [],
            original_room_types_selected: [],
            loading_save: false,

            rate_plan: this.$clone(defaults.rate_plan_item),
            original_item: this.$clone(defaults.rate_plan_item),

        };
    },

    computed: {
        meal_type: {
            // getter
            get: function () {
                switch (true) {
                case (this.breakfast && this.lunch && this.dinner && !this.all_inclusive):
                    return 'breakfast_lunch_dinner'
                    break;
                case (this.breakfast && !this.lunch && !this.dinner && !this.all_inclusive):
                    return 'breakfast'
                    break;
                case (this.breakfast && this.lunch && !this.dinner && !this.all_inclusive):
                    return 'breakfast_lunch'
                    break;
                case (this.breakfast && !this.lunch && this.dinner && !this.all_inclusive):
                    return 'breakfast_dinner'
                    break;
                case (!this.breakfast && this.lunch && this.dinner && !this.all_inclusive):
                    return 'lunch_dinner'
                    break;
                case (!this.breakfast && !this.lunch && !this.dinner && !this.all_inclusive):
                    return 'room-only'
                    break;
                case (!this.breakfast && !this.lunch && this.dinner && !this.all_inclusive):
                    return 'dinner'
                    break;
                case (!this.breakfast && this.lunch && !this.dinner && !this.all_inclusive):
                    return 'lunch'
                    break;
                case (this.all_inclusive):
                    return 'all-inclusive'
                    break;
                default:
                    return '';
                }
            },
            // setter
            set: function (newValue) {
                // this.rate_plan.meal_type = newValue;
                switch (newValue) {
                case ('romm-only'):
                    this.breakfast = false;
                    this.lunch = false;
                    this.dinner = false;
                    this.all_inclusive = false;
                    break;
                case ('breakfast'):
                    this.breakfast = true;
                    this.lunch = false;
                    this.dinner = false;
                    this.all_inclusive = false;
                    break;
                case ('breakfast_lunch'):
                    this.breakfast = true;
                    this.lunch = true;
                    this.dinner = false;
                    this.all_inclusive = false;
                    break;
                case ('breakfast_dinner'):
                    this.breakfast = true;
                    this.lunch = false;
                    this.dinner = true;
                    this.all_inclusive = false;
                    break;
                case ('breakfast_lunch_dinner'):
                    this.breakfast = true;
                    this.lunch = true;
                    this.dinner = true;
                    this.all_inclusive = false;
                    break;
                case ('lunch'):
                    this.breakfast = false;
                    this.lunch = true;
                    this.dinner = false;
                    this.all_inclusive = false;
                    break;
                case ('lunch_dinner'):
                    this.breakfast = false;
                    this.lunch = true;
                    this.dinner = true;
                    this.all_inclusive = false;
                    break;
                case ('dinner'):
                    this.breakfast = false;
                    this.lunch = false;
                    this.dinner = true;
                    this.all_inclusive = false;
                    break;
                case ('all-inclusive'):
                    this.breakfast = true;
                    this.lunch = true;
                    this.dinner = true;
                    this.all_inclusive = true;
                    break;
                }
            }
        },

        rules() {
            return {
                name: [v => !!v || this.$t('rate_plan.form_rules.name')],
                meal: [v => !!v || this.$t('rate_plan.form_rules.meal')],
                parent: [v => !!v || 'Plan necesar'],
            }
        },
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                } else {
                    this.getAllItems();
                }
            },
            deep: true,
            immediate: true
        },

        parent: {
            handler: function (newValue) {
                if(newValue) {
                    if(!this.rate_plan.config.formula) {
                        this.$set(this.rate_plan.config, 'formula', {
                            'operation': 'add',
                            'type': 'percent',
                            'value': 20
                        })
                    }
                } else {
                    this.rate_plan.parent_id = null;
                    this.rate_plan.config.formula = null;
                }
            },
        },

        rate_plan: {
            handler: function () {
                if(!this.rate_plan.config) {
                    this.rate_plan.config = this.$clone(defaults.rate_plan_item.config)
                }
                this.modified = (JSON.stringify({ ...this.rate_plan
                }) == JSON.stringify({ ...this.original_item
                }));
                this.days.forEach(function (day, index) {
                    if(this.rate_plan.config.weekdays.includes(day.value)) {
                        day.selected = true;
                    } else {
                        day.selected = false;
                    }
                }.bind(this))
            },
            deep: true
        },

        room_types_selected: {
            handler: function () {
                this.modified_room_selection = !(JSON.stringify({ ...this.room_types_selected
                }) == JSON.stringify({ ...this.original_room_types_selected
                }));
            },
            deep: true
        },

        'hotel.id': function (new_hotel, old_hotel) {
            if(new_hotel !== JSON.parse(localStorage.getItem('hotel'))
                .id) {
                this.$router.push({
                    path: '/' + this.hotel.slug + '/rate-plans'
                });
            }
        }
    },

    async mounted() {
        this.getAllItems;
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        getAllItems() {
            this.loading_data = true;

            this.getItemConfigs()
                .then(() => this.getPolicies())
                .then(() => this.getRatePlans())
                .then(() => this.getRoomTypes())
                .then(() => this.getItem())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading_data = false;
                    if(this.$route.params.id) {
                        this.name = this.rate_plan.name;
                    }
                });
        },

        getItemConfigs() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/config';

            return this.$axios.get(endpoint)
                .then(response => {
                    this.parent_fromula = response.data.rate_plan_formula;

                    this.meal_types = response.data.meal_types;
                    // let pos = []
                    // Object.entries(response.data.points_of_sale)
                    //     .forEach(([key, value]) => {
                    //         pos.push({
                    //             slug: key,
                    //             name: value,
                    //             sale: false
                    //         })
                    //     });
                    // this.points_of_sales = pos;

                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
        },

        getItem() {

            if(this.$route.params.id == undefined) {
                // set default cancellation policy for create new rate plan
                if(this.policies.length > 0) {
                    this.rate_plan.cancellation_policy_id = this.policies[0].id
                }
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/rate-plans/' + this.$route.params.id;

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    // redirect when hotel_id doesn't macth
                    if(this.hotel.id !== response.data.hotel_id) {
                        this.error(this.$t('rate_plan.message_no_access'));
                        this.$router.push({
                            path: '/dashboard'
                        });
                        return
                    }
                    if(!!response.data.parent_id) {
                        this.parent = true;
                    } else {
                        this.parent = false;
                    }
                    this.rate_plan = response.data;
                    this.meal_type = this.rate_plan.meal_type;
                    this.original_item = this.$clone(this.rate_plan);
                    response.data.room_types.forEach(function (room_type) {
                        this.room_types_selected.push(room_type.id)
                    }.bind(this))
                    this.original_room_types_selected = this.$clone(this.room_types_selected);
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                })

        },

        saveItem() {
            if(!this.rate_plan.name) {
                this.error_data = true;
            }

            if(!this.$refs.form_rate_plan.value) {
                this.$refs.form_rate_plan.validate();
                return
            }

            this.loading_save = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/rate-plans/';

            let item = this.rate_plan;
            item.room_types = this.room_types_selected;
            item.meal_type = this.meal_type;

            if(this.$route.params.id !== undefined) {
                this.$axios.put(endpoint + item.id, item)
                    .then(response => {
                        this.success(this.$t('rate_plan.message_edited_rate_plan'));
                        this.$router.push({
                            path: '/' + this.hotel.slug + '/rate-plans'
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                item.hotel_id = this.hotel.id;
                this.$axios.post(endpoint, item)
                    .then(response => {
                        this.success(this.$t('rate_plan.message_created_rate_plan'));
                        this.$router.push({
                            path: '/' + this.hotel.slug + '/rate-plans'
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        getRatePlans() {
            if(!this.hotel.id) {
                return
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel.id
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.parent_plans = response.data.data.filter(item => (item.id != this.$route.params.id) && (item.parent_id == null));
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getPolicies() {
            if(!this.hotel.id) {
                return
            }
            // we are currently loading
            this.loading = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/cancellation-policies";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.policies = response.data.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });

                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getRoomTypes() {
            if(!this.hotel.id) {
                return;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // we are currently loading
            this.loading = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.room_types = response.data.data;
                    if(!this.$route.params.id) {
                        this.room_types.map(room => this.room_types_selected.push(room.id))
                    }
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteItem() {
            this.delete_dialog = true;
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans/";

            let params = {
                params: {
                    hotel_id: this.hotel.id,
                }
            };

            // call delete endpoint
            this.$axios.delete(endpoint + this.$route.params.id, params)
                .then(response => {
                    this.success(this.$t('rate_plan.message_deleted_rate_plan'));
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                    this.delete_dialog = false;
                    this.$router.push({
                        path: '/' + this.hotel.slug + '/rate-plans'
                    });
                });
        },

        refresh() {
            if(!this.$route.params.id) {
                this.$refs.form_rate_plan.reset();
                this.rate_plan = this.$clone(defaults.rate_plan_item);
                this.$refs.form_rate_plan
            } else {
                this.$refs.form_rate_plan.reset();
                this.getItem();
            }
        },

        back() {
            this.$router.push({
                path: '/' + this.hotel.slug + '/rate-plans'
            });
        },

        toSheetRoomMeal() {
            this.$router.push({
                path: '/' + this.hotel.slug + '/pricing-rooms-meals'
            });
        },

        selectDays(day) {
            day.selected = !day.selected;
            if(day.selected) {
                this.rate_plan.config.weekdays.push(day.value)
            } else {
                let index = this.rate_plan.config.weekdays.indexOf(day.value);
                this.rate_plan.config.weekdays.splice(index, 1);
            }
        },
    }
};
</script>
<style lang="stylus">
.v-progress-linear
    &.progress-bar
        position: absolute
        bottom: 0 auto
/* always present */
.expand-transition
    transition: all 2.8s ease
    height: 30px
    padding: 10px
    background-color: #eee
    overflow: hidden
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter
    height: 0
    padding: 0 10px
    opacity: 0
.expand-leave
    height: 0
    padding: 0 10px
    opacity: 0
.number-input
    input[type="number"]
        -moz-appearance: textfield
        &::-webkit-outer-spin-button
            -webkit-appearance: none
            margin: 0
        &::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
</style>
